<template>
  <Tooltip
    v-if="resource && resource.id > 0"
    placement="top"
    :options="tooltipOptions"
    style="display: block"
  >
    <template #trigger>
      <div>
        <truncate-text :expand="false">
          <div
            v-if="timeCardsEnabled"
            class="inline-flex items-center relative top-1 clock-in-icon"
          >
            <div
              :class="`mr-1 status-label ${profile.user_id}-clocked-in-icon ${
                initialClockedInState ? '' : 'hidden'
              }`"
            >
              <StopwatchIcon class="w-[16px]" />
            </div>
            <div
              :class="`mr-1 status-label ${profile.user_id}-clocked-out-icon ${
                initialClockedInState ? 'hidden' : ''
              }`"
            >
              <StopwatchCensoredIcon class="w-[16px]" />
            </div>
          </div>
          <Link :to="profile.resource_path">
            <i v-if="profile.installer" class="fas fa-wrench mr-1"></i>
            {{ resource.title }}
          </Link>
        </truncate-text>
      </div>
    </template>
    <template #tooltip>
      <div>
        <div class="tech-tooltip-wrapper">
          <div class="tech-tooltip tooltip-cont d-flex align-items-center">
            <div
              class="tech-profile-img mr-2"
              :style="{
                'background-image': `url(${profile.avatar.url})`
              }"
            />
            <div class="d-flex flex-column">
              <span
                ><i class="fas fa-phone mr-1 light-icon"></i
                >{{ profile.phone }}</span
              >
              <span
                ><i class="fas fa-home mr-1 light-icon"></i
                >{{ profile.address.city }}</span
              >
              <span class="skill-level"
                ><i class="fas fa-id-card mr-1 light-icon"></i
                >{{ profile.skill_level }}</span
              >
              <span v-if="profile.installer"
                ><i class="fas fa-wrench mr-1 light-icon"></i>Installer</span
              >
            </div>
          </div>
          <div class="tooltip-divider"></div>
          <div class="crew-member-tooltip">
            <div><b>Crew Members </b> (Current)</div>
            <div v-if="!profile.crew_members.length" class="crew-row">--</div>
            <div
              v-for="member in profile.crew_members"
              v-else
              :key="member.id"
              class="crew-row"
            >
              <span>{{ member.full_name }}</span
              ><span>{{ member.phone }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Tooltip>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import Link from "@/components/Link.vue";
import Tooltip from "@/components/Tooltip.vue";
import TruncateText from "@/components/TruncateText.vue";
import StopwatchIcon from "@/images/stopwatch.svg?component";
import StopwatchCensoredIcon from "@/images/stopwatch-censored.svg?component";

const store = useStore();
const props = defineProps<{
  resource?: object;
}>();

// Sets the initial icon based on clocked-in status
// After page load, the icons are toggled via jquery in response to the Admins::TimeClockChannel
const initialClockedInState = ref(props.resource?.extendedProps.is_clocked_in);
const profile = computed(() => props.resource?.extendedProps);

const tooltipOptions = computed(() => ({ interactive: false }));

const timeCardsEnabled = computed(() => store.state.tenant?.time_cards_enabled);
</script>

<style lang="scss" scoped>
.tech-profile-img {
  background-position: center;
  height: 45px;
  width: 45px;
  background-size: cover;
  border-radius: 50%;
}
.clock-in-icon {
  position: relative;
  top: -2px;
}
</style>
